"use strict";
var dragula_class_1 = require("./components/dragula.class");
exports.dragula = dragula_class_1.dragula;
var dragula_directive_1 = require("./components/dragula.directive");
exports.DragulaDirective = dragula_directive_1.DragulaDirective;
var dragula_provider_1 = require("./components/dragula.provider");
exports.DragulaService = dragula_provider_1.DragulaService;
var dragular_module_1 = require("./components/dragular.module");
exports.DragulaModule = dragular_module_1.DragulaModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-dragula/index.js
// module id = 902
// module chunks = 9